import { useRef, useState } from "react";
import axios from "../api/axiosClient";
import {
    Box,
    Button,
    Grid
} from "@mui/material";
import { useIntl } from "react-intl";
import { useLoading } from "../components/LoadingContext";
import PageHeader from "../components/ui/PageHeader";
import CustomInput from "../components/ui/CustomInput";
import { errorToast, handleError } from "../services/serviceBase";
import toast from "react-hot-toast";
import DownloadExcelModal from "../components/Modals/DownloadExcelModal";
import { useSelector } from "react-redux";

const UploadExcel = ({ type }) => {
    const intl = useIntl();
    const { setLoading } = useLoading();
    const fileRef = useRef(null);

    const [downloadLink, setDownloadLink] = useState("");
    const [openDownloadModal, setOpenDownloadModal] = useState(false);

    const idCompany = useSelector((state) => state.common.company);

    const getApiUrl = () => {
        switch (type) {
            case "UrgentFlag":
                return "/returnfiles/urgent";
            case "TrackingData":
                return "/returnfiles/trackingdata";
            case "ToBeRepaired":
                return "/returnfiles/toberepaired";
            case "MassiveClosure":
                return "/returnfiles/massiveclosure";
            default:
                return "/returnfiles/urgent";
        }
    };

    const getTitleMessageId = () => {
        switch (type) {
            case "UrgentFlag":
                return "UrgentFlagMassiveUpdate.Title";
            case "TrackingData":
                return "TrackingData.Title";
            case "ToBeRepaired":
                return "ToBeRepaired.Title";
            case "MassiveClosure":
                return "MassiveClosure.Title";
            default:
                return "UrgentFlagMassiveUpdate.Title";
        }
    };

    const handleUploadFile = () => {
        setLoading(true);

        const params = new URLSearchParams([]);
        params.append("idCompany", idCompany);

        const data = new FormData();
        data.append("file", fileRef.current.files[0]);
        var url = getApiUrl();
        if (params.size > 0) {
            url += "?" + params.toString();
        }

        axios
            .post(url, data)
            .then((response) => {
                if(response.data !== "" && response.data != undefined){
                    setDownloadLink(response.data)
                    setOpenDownloadModal(true);
                }
                else{
                    toast.success("Updated!");
                }
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                handleError(error, intl);
            });
    };

    return (
        <Box>
            <PageHeader title={intl.formatMessage({ id: getTitleMessageId() })} />
            
            <Grid container sx={{ mt: 1 }}>
                <Grid item md={4}>
                    <CustomInput
                        labelText={intl.formatMessage({
                            id: "General.SelectExcelFile",
                        })}
                        type="file"
                        valueRef={fileRef}
                        acceptedContentTypes="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    />
                </Grid>
                <Grid item md={2}>
                    <Button
                        size="small"
                        variant="contained"
                        sx={{ width: "100%" }}
                        className="apeLigthBlueBackground"
                        onClick={handleUploadFile}
                    >
                        {intl.formatMessage({ id: "General.Upload" })}
                    </Button>
                </Grid>
            </Grid>

            <DownloadExcelModal
                downloadLink={downloadLink}
                openDownloadModal={openDownloadModal}
            ></DownloadExcelModal>
        </Box>
    );
};

export default UploadExcel;
